module.exports = __webpack_public_path__ + "img/logo-topleft.1499d2e0.svg";